import 'intersection-observer'
import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { decodeHTMLEntities, gtmPush } from '../../../../../helpers'
import { pretty_date } from '../../../../../utils'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { link, linkWrapper } from '../../../../cms/blocks/utils.gen'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { ButtonData } from '../../../../wordpress/types_and_parser/extra_types.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { getImageAttribute } from '../../../utils/extra_images.mod'


export type HeaderAttributes = {
  blockName: 'vidda/header'
  header_type: 'header one' | 'header two' | 'header three' | 'home' | 'error'
  title: string
  // subtitle?: string
  intro?: string
  // image_focus?: 'top' | 'middle' | 'bottom'
  image?: WordPress.MediaResponse
  image_mobile?: WordPress.MediaResponse
  primary_button?: ButtonData
  secondary_button?: ButtonData
  link_to_form_block?: boolean
  open_primary_new_tab?: boolean
  open_secondary_new_tab?: boolean
  // video_small?: string
  // video_medium?: string
  // video_large?: string
}

export interface HeaderInterface {
  blockName: 'vidda/header'
  attrs: HeaderAttributes
}

export type HeaderBlockProps<extra_images> = HeaderAttributes

export type HeaderBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

export const StringToHeaderType = (input: string) =>
  input === 'home'
    ? 'home'
    : input === 'header one'
      ? 'header one'
      : input === 'header two'
        ? 'header two'
        : input === 'header three'
          ? 'header three'
          : input === 'error'
            ? 'error'
            : 'header one'


export function HeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    // TODO: Put event date inside header for event detail pages
    if (public_state.page.page.kind == 'loaded') {
      let date = pretty_date((public_state.page.page.value.extra_data?.post?.acf as any)?.event_date)
    }
    return mk_widget({ 
      run: _ => (
        props.header_type == 'home' ? homepageHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
          props.header_type == 'header one' ? primaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
            props.header_type == 'header two' ? secondaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
              props.header_type == 'error' ? errorHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) :
                primaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { })
      )
    })
  }
}

export function errorHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <header className='page-header ph--generic ph--primary ph--text' >
          <div className="ph__inner container container--m gutter--m">
            <div className="ph__content spacing--l">
              <div className="hero__text">
                {props.title && <h1 className="ph__title typo--xl">{decodeHTMLEntities(props.title)}</h1>}
                {props.intro && <div className=" ph__intro ff--primary text--styled">{decodeHTMLEntities(props.intro)}</div>}
              </div>
            </div>
          </div>
        </header>
      )
    })
  }
}


export function homepageHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }

): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: (_) => (
        <header className="page-header ph--home">
          <div className="ph__inner">
            <div className="ph__content spacing--xl gutter--l">
              <div className="ph__wrap">
                {props.title && <h1 className="ph__title">{decodeHTMLEntities(props.title)}</h1>}
                {props.intro && (
                  <div className=" ph__intro ff--primary text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
                )}
                {(props.primary_button || props.secondary_button) && (
                  <ul className="ph__buttons ph__footer ls-clickables">
                    {props.primary_button && (
                      <li className="ph__button ls-clickable">
                        {link(linkWrapper({ title: props.primary_button.text, url: props.primary_button.url }, props.open_primary_new_tab),
                          { classname: 'button button--primary' },
                          props.primary_button.text, 
                          () => {
                            gtmPush({
                              event: 'header', 
                              cta_type: 'primary_button', 
                              click_text: props.primary_button.text
                            })
                          }
                        )}
                      </li>
                    )}
                    {props.secondary_button && (
                      <li className="ph__button ls-clickable">
                        {link(linkWrapper({ title: props.secondary_button.text, url: props.secondary_button.url }, props.open_secondary_new_tab),
                          { classname: 'button button--tertiary' },
                          props.secondary_button.text,
                          () => {
                            gtmPush({
                              event: 'header', 
                              cta_type: 'secondary_button', 
                              click_text: props.secondary_button.text
                            })
                          }
                        )}
                      </li>
                    )}
                  </ul>
                )}
              </div>
            </div>
            {(props.image && props.image.media_details && (<div className="ph__visual">
              <img
                src={getImageAttribute(props.image, 'header-home-l', 'source_url')}
                width={getImageAttribute(props.image, 'header-home-l', 'width')}
                height={getImageAttribute(props.image, 'header-home-l', 'height')}
                className="ph__image"
                alt={props.image.alt_text ? props.image.alt_text : ''}
              />
            </div>))}
          </div>
        </header>
      ),
    })
  }
}


/**
 * Header #1 has 
 * - image 
 * - title 
 * - intro
 * @param props 
 * @param options 
 * @returns 
 */
export function primaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => {
        const isHome = s.custom_page_data && s.custom_page_data.v.kind == 'r' && s.custom_page_data.v.v.post && s.custom_page_data.v.v.post.is_front;
        return (
          <header className={`page-header ph--generic ph--primary ph--${props.image ? 'image' : 'text'}`}>
            <div className="ph__inner container container--m gutter--m">
              <div className={`ph__content spacing--l${props.image ? ' ls-second-item' : ''}`}>
                {props.title && <h1 className="ph__title typo--xl ff--primary"dangerouslySetInnerHTML={{ __html: props.title}} />}
                {props.intro && <div className=" ph__intro ff--primary text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />}
                {(props.primary_button || props.secondary_button) && (
                  <ul className="ph__footer ls-clickables">
                    {props.primary_button && (
                      <li className="ph__button ls-clickable">
                        {props.link_to_form_block ? 
                          <a className='button button--primary' target='_self' href='#form-block'>{props.primary_button.text}</a>
                        :
                          link(linkWrapper({ title: props.primary_button.text, url:  props.primary_button.url }, props.open_primary_new_tab),
                            { classname: 'button button--primary' },
                            props.primary_button.text, 
                            () => {
                              gtmPush({
                                event: 'header', 
                                cta_type: 'primary_button', 
                                click_text: props.primary_button.text
                              })
                            }
                          )
                        }
                      </li>
                    )}
                    {props.secondary_button && (
                      <li className="ph__button ls-clickable">
                        {link(linkWrapper({ title: props.secondary_button.text, url: props.secondary_button.url }, props.open_secondary_new_tab),
                          { classname: 'button button--tertiary' },
                          props.secondary_button.text, 
                          () => {
                            gtmPush({
                              event: 'header', 
                              cta_type: 'secondary_button', 
                              click_text: props.secondary_button.text
                            })
                          }
                        )}
                      </li>
                    )}
                  </ul>
                )}
              </div>
              {props.image && props.image.media_details && (
                <div className="ph__visual ls-first-item">
                  <img
                    src={getImageAttribute(props.image, 'shared-l', 'source_url')}
                    width={getImageAttribute(props.image, 'shared-l', 'width')}
                    height={getImageAttribute(props.image, 'shared-l', 'height')}
                    className="ph__image border-radius--s"
                    alt={props.image.alt_text ? props.image.alt_text : ''}
                  />
                </div>)}
            </div>
          </header>)
      }
    })
  }
}

/**
 * Header #2 
 * - Title 
 * - Intro 
 * - image 
 * - buttons 
 * 
 * @param props 
 * @param options 
 * @returns 
 */
export function secondaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <header className={`page-header ph--generic ph--secondary ph--${props.image ? 'image' : 'text'}`}>
          <div className="ph__inner container container--m gutter--m">
            <div className={`ph__content spacing--l${props.image ? ' ls-second-item' : ''}`}>
              {props.title && <h1 className="ph__title typo--xl ff--primary">{decodeHTMLEntities(props.title)}</h1>}
              {props.intro && <div className=" ph__intro ff--primary text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />}
              {(props.primary_button || props.secondary_button) && (
                <ul className="ph__footer ls-clickables">
                  {props.primary_button && (
                    <li className="ph__button ls-clickable">
                      {props.link_to_form_block ? 
                        <a className='button button--quaternary' target='_self' href='#form-block'>{props.primary_button.text}</a>
                      :
                        link(linkWrapper({ title: props.primary_button.text, url:  props.primary_button.url }, props.open_primary_new_tab),
                          { classname: 'button button--quaternary' },
                          props.primary_button.text, 
                          () => {
                            gtmPush({
                              event: 'header', 
                              cta_type: 'primary_button', 
                              click_text: props.primary_button.text
                            })
                          }
                        )
                      }
                    </li>
                  )}
                  {props.secondary_button && (
                    <li className="ph__button ls-clickable">
                      {link(linkWrapper({ title: props.secondary_button.text, url: props.secondary_button.url}, props.open_secondary_new_tab),
                        { classname: 'button button--quaternary' },
                        props.secondary_button.text, 
                        () => {
                          gtmPush({
                            event: 'header', 
                            cta_type: 'secondary_button', 
                            click_text: props.secondary_button.text
                          })
                        }
                      )}
                    </li>
                  )}
                </ul>
              )}
            </div>
            {props.image && props.image.media_details && (
              <div className="ph__visual ls-first-item">
                <img
                  src={getImageAttribute(props.image, 'shared-l', 'source_url')}
                  width={getImageAttribute(props.image, 'shared-l', 'width')}
                  height={getImageAttribute(props.image, 'shared-l', 'height')}
                  className="ph__image border-radius--s"
                  alt={props.image.alt_text ? props.image.alt_text : ''}
                />
              </div>)}
          </div>
        </header>
      )
    })
  }
}

